import isEmpty from 'lodash';

export function getRecentSearches(recentSearchs) {
    const { query: recentSearch } = JSON.parse(recentSearchs)?.[0] ?? {};

    return recentSearch && {
        makeCode: recentSearch.makeCodeList,
        zip: recentSearch.zip,
        listingType: recentSearch.listingTypes?.toUpperCase(),
        searchRadius: recentSearch.searchRadius,
        minPrice: recentSearch.minPrice,
        maxPrice: recentSearch.maxPrice,
        startYear: recentSearch.startYear,
        endYear: recentSearch.endYear,
    };
}

export function getPersonalization(peData) {
    const { topRankedVehicle = {} } = JSON.parse(peData)?.preferences ?? {};

    return !isEmpty(topRankedVehicle) && {
        makeCode: topRankedVehicle.make.code,
    }
}
